export class MotorQuoteUIDO {

  // public name: any = null;
  // public email: any = null;
  // public mobile: any = null;
  public leadRefNum: any = null;
  public currencyCd: any = null;

  public make: any = null;
  public model: any = null;
  public variant: any = null;
  public seatingCapacity: any = null;
  public bodyType: any = null;
  public vehicleKey: any = null;

  public usage: any = null;
  public plateNumber: any = null;
  public region: any = null;
  public manufacturingYear: any = null;
  public category: any = null;

  public sumInsured: Number = null;
  public estimatedPrice: any = null;

  public startDate: any = null;
  public endDate: any = null;
  public term: any = null;

  public ratingType: any = null;
  public discount: any = 0;

  public products: any = [];
  public scheduleList: any = [];
  public quotationListForEditMode: any = []

  public isUIDO = true;
  public isEditMode = null;
  public isFromLead = null;

  constructor() { }



}